import styled from '@emotion/styled';
import type { MaterialSymbolOptions } from 'storybookConfig/mixins/materialSymbol';
import materialSymbol from 'storybookConfig/mixins/materialSymbol';
import Button from 'storybookConfig/stories/molecules/Button';

type IconButtonProps = MaterialSymbolOptions & {
  /**
   * The icon is drawn in CSS and the button has no text, so this is its only accessible name.
   */
  'aria-label': string;
};

/**
 * Composes an icon as a button.
 */
const IconButton = styled(Button, {
  shouldForwardProp: (prop) => !['additionalStyling'].includes(prop),
})<IconButtonProps>`
  ${(options) => materialSymbol(options)};
`;

export default IconButton;
